module.exports = __webpack_public_path__ + "static/img/ic_launcher_round.725506c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_launcher_round.png
// module id = s6zk
// module chunks = 1